import SimpleWhiteBox from "./SimpleWhiteBox";

export default function WhiteCard(props) {
  
  return (

    <SimpleWhiteBox content={
      <div className="row" onClick={() => props.selected(props.id)} style={{cursor:'pointer'}} >
        <div className="col-10">
          {props.content}
        </div>
        <div className="col-2 ">
          <div style={{float:'right'}}>
            {props.icon}
          </div>
        </div>
      </div>
    }
    />
    
    
  )
}

export function WhiteCardNoIcon(props){
  return (

    <SimpleWhiteBox content={
      <div className="row" onClick={() => props.selected(props.id)} style={{cursor:'pointer'}} >
        {props.content}
      </div>
    }
    />
    
    
  )
}